export { getOnePageData } from './api/onePageDataApi';
export { useOnePageData, onePageQueryKeys } from './model';
